<div class="pt-4 pb-4">
  <gstar-tax-rate-summaries-box class="d-block mb-3" />
</div>
